<template>
	<!-- 关于我们 -->
	<div class="about">
		<!-- top -->
		<headers/>
		<!-- 内容 -->
		<div class="common">
			<div class="banner">
				<div class="bannerCont">
					<p class="p1">联系我们：<span>400-6895223</span></p>
					<p class="p2">（工作日：8：00-17:00）</p>
				</div>
				<div class="address">
					<p class="p2">山东智能好停车股份有限公司</p>
					<p class="p2">地址：聊城高新区庐山路产业园内</p>
				</div>
			</div>
			<!-- 联系我们地图 -->
			<div class="contact">
				<p class="contactP">联系我们</p>
				<p class="contactP2">CONTACT US</p>
				<baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:700px" :scroll-wheel-zoom='true'>
				</baidu-map>
			</div>
		</div>
		<!-- bottom -->
		<footers></footers>
	</div>
</template>

<script>
	import headers from '@/components/header.vue'
	import footers from '@/components/footer.vue'
	export default{
		data(){
			return{
				center: {lng:116.063779, lat:36.450015},
				zoom: 13
			}
		},
		methods:{
			handler ({BMap, map}) {
				var point = new BMap.Point(116.063779, 36.450015)
				map.centerAndZoom(point, 13)
				var marker = new BMap.Marker(point) // 创建标注
				map.addOverlay(marker) // 将标注添加到地图中
				var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
				map.addOverlay(circle)
			}
		},
		components:{
			headers,footers
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.banner{
		width: 100%;
		height:800px;
		margin: 0 auto;
		vertical-align: middle;
		position: relative;
		background: url(../../assets/images/contact.png) center no-repeat;
		background-size:100% 100%;
		text-align: center;
		.bannerCont{
			width: 1200px;
			height: 380px;
			padding-top: 200px;
			color: #fff;
			margin: 0 auto;
			text-align:left;
			.p1{
				font-size: 28px;
				padding: 10px;
				font-weight: bold;
				span{
					font-size: 28px;
					padding-left: 10px;
					letter-spacing: 5px;
				}
			}
			.p2{
				font-size:28px;
				letter-spacing: 5px;
				font-weight: bold;
			}
		}
		.address{
			width: 1200px;
			margin: 0 auto;
			text-align: left;
			.p2{
				color: #fff;
				font-size: 16px;
				line-height: 2;
			}
		}
	}
	.public{
		width: 1200px;
		margin: 0 auto;
	}
	.contact{
		.contactP{
			margin-top: 20px;
			padding: 10px 0;
			font-size: 28px;
			font-weight: bold;
		}
		.contactP2{
			margin-bottom: 20px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/contact/contact.vue